import { render, staticRenderFns } from "./OneTouchFile.vue?vue&type=template&id=df009010&scoped=true&"
import script from "./OneTouchFile.vue?vue&type=script&lang=js&"
export * from "./OneTouchFile.vue?vue&type=script&lang=js&"
import style0 from "./OneTouchFile.vue?vue&type=style&index=0&id=df009010&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df009010",
  null
  
)

export default component.exports